export default __webpack_public_path__ + "static/media/icon.168822a2.png";